var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95631 2.87337L2.95725 2.87251C3.60419 2.28977 4.52269 1.91174 6.19859 1.70888C7.9028 1.50259 10.1526 1.5 13.3333 1.5H16.6667C19.8474 1.5 22.0972 1.50259 23.8014 1.70888C25.4773 1.91174 26.3958 2.28977 27.0427 2.87252L27.0437 2.87337C27.6686 3.43531 28.0576 4.20153 28.2723 5.6382C28.4961 7.13561 28.5 9.12477 28.5 12V18C28.5 20.8752 28.4961 22.8644 28.2723 24.3618C28.0576 25.7985 27.6686 26.5647 27.0437 27.1266L27.0427 27.1275C26.3958 27.7102 25.4773 28.0883 23.8014 28.2911C22.0972 28.4974 19.8474 28.5 16.6667 28.5H13.3333C10.1526 28.5 7.9028 28.4974 6.19859 28.2911C4.52269 28.0883 3.60419 27.7102 2.95725 27.1275L2.95631 27.1266C2.33139 26.5647 1.94239 25.7985 1.72769 24.3618C1.50392 22.8644 1.5 20.8752 1.5 18V12C1.5 9.12477 1.50392 7.13561 1.72769 5.6382C1.94239 4.20153 2.33139 3.43531 2.95631 2.87337Z",
    stroke: "#4B2D10",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 12H21.6667M8.33337 18H16.6667",
    stroke: "#4B2D10",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsNavigation);
export default __webpack_public_path__ + "static/media/adsNavigation.d882cf9c04dac044f68cecbff45c35a1.svg";
export { ForwardRef as ReactComponent };